$('.js-cookieClose').on('click', () => {
  $('.cookie').remove()
})
